import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson, SnakeCaseObject } from '@client/core/data/concerns/parses-from-json';
import { HttpResponse } from '@client/core/http/types';
import { snakeCaseKeys } from '@client/core/utils/snake-case-keys';
import { RepairItem } from '@client/features/repair-item/models/repair-item';

export class RepairItemDataSource extends DataSource {
  async update(repairItem: RepairItem): Promise<RepairItem> {
    const response = await this.httpClient.patch<HttpResponse<RepairItem>>(
      `/repair-items/${repairItem.id}`,
      repairItemToRequest(repairItem),
    );

    return fromJson(RepairItem, response.data);
  }
}

export function repairItemToRequest(repairItem: RepairItem): SnakeCaseObject<RepairItem> {
  return {
    ...snakeCaseKeys(repairItem),
    material_category: repairItem.materialCategory ? repairItem.materialCategory.slug : null,
  };
}
